import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./DeleteModal.css";
import { toast } from "react-toastify";
import { dispatcher } from "../../store/storeHelpers";
import moment from "moment";
import * as actionTypes from "../../store/ActionTypes";
import { updateContainerData, updateAggregateContainerData, updateFiveMContainerData  } from "../../services/ContainerMasterService";

function FactoryOutModal({ show, hide, cell, user, setDisableGateOutBtn }) {
  const [showDeleteProcess, setShowDeleteProcess] = useState("Yes");

  function yesClickHandler() {
    async function deleteShipment() {
      try {
        if (cell.row.original.DataOf === "TRACTOR") {
          setDisableGateOutBtn(true);
          updateContainerData({
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD HH:mm:ss"),
            UserId: user.uid,
          });
          dispatcher(actionTypes.CONTAINER_GATE_OUT, {
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD hh:mm A"),
            UserId: user.uid,
          });
          setDisableGateOutBtn(false);
        }
        if (cell.row.original.DataOf === "AGGREGATE") {
          setDisableGateOutBtn(true);
          updateAggregateContainerData({
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD HH:mm:ss"),
            UserId: user.uid,
          });
          dispatcher(actionTypes.CONTAINER_GATE_OUT, {
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD hh:mm A"),
            UserId: user.uid,
          });
          setDisableGateOutBtn(false);
        }
        if (cell.row.original.DataOf === "5M") {
          setDisableGateOutBtn(true);
          updateFiveMContainerData({
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD HH:mm:ss"),
            UserId: user.uid,
          });
          dispatcher(actionTypes.CONTAINER_GATE_OUT, {
            Id: `${cell.row.original["ContainerMasterId"]}`,
            columnName: "Gate_Out_Date",
            prevVal: "-",
            value: moment().format("YYYY-MM-DD hh:mm A"),
            UserId: user.uid,
          });
          setDisableGateOutBtn(false);
        }
        toast.success(
          `"Factory Out Date & Time" column updated with "${moment().format(
            "DD-MM-YYYY hh:mm A"
          )}"`
        );
        hide()
      } catch (error) {
        setShowDeleteProcess("Yes");
      }
    }
    deleteShipment();
  }
  return (
    <>
      <Modal
        show={show}
        centered
        className="DeleteModal"
        dialogClassName="deleteWidthClass"
        contentClassName="deleteHeightClass"
      >
        <Modal.Header style={{
     display: "flex",
     justifyContent: "center",
     alignItems: "center",
        }}>
        <div className="DeleteModal__title">Alert</div>
        </Modal.Header>
        <Modal.Body>
          <div className="DeleteModal__container">
         
            <div className="DeleteModal__description">Invoice Number and relevant documents are missing.</div>
            <div className="DeleteModal__Btn">
              <Button className="DeleteModal__noBtn" onClick={() => hide()}>
                Ok
              </Button>
              {/* <Button
                className="DeleteModal__yesBtn"
                onClick={yesClickHandler}
                disabled={showDeleteProcess === "Deleting..."}
              >
                {showDeleteProcess}
              </Button> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default FactoryOutModal;
